import { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when retailer has seen a Tip for the holiday spend challenge and reset when there is a new Tip
 */
export const GROW_WITH_FAIRE_CURRENT_TIP_SEEN =
  'GROW_WITH_FAIRE_CURRENT_TIP_SEEN' as IUserMilestone.RetailerMilestone;
